export default __webpack_public_path__ + "static/media/oats 2.bccd543b.jpg";